<div class="input-group stc-input-group" *ngIf="control">
  <label
    >{{ inputName }}
    <mat-error
      *ngIf="control.hasError('required') || control.hasError('whitespace')"
      >*
    </mat-error></label
  >
  <mat-form-field class="">
    <textarea
      matInput
      rows="5"
      [id]="inputId"
      [name]="inputName"
      [placeholder]="inputPlaceholder ? inputPlaceholder : ''"
      [formControl]="control"
      (keydown)="onKeyDown($event)"
    ></textarea>
    <mat-error
      *ngIf="control.hasError('required') || control.hasError('whitespace')"
      >{{ 'field_required' | translate }}
    </mat-error>
    <mat-error *ngIf="control.hasError('maxlength') && !selfServiceMsg"
      >{{
        'Please enter text less than ' +
          control.getError('maxlength').requiredLength +
          ' character' | translate
      }}
    </mat-error>
    <mat-error *ngIf="control.hasError('maxlength') && selfServiceMsg"
      >{{
        'Please enter text less than or equal' +
          control.getError('maxlength').requiredLength +
          ' character' | translate
      }}
    </mat-error>
  </mat-form-field>
</div>
